import { HubConnectionBuilder } from '@microsoft/signalr';

const combineURLs = (baseURL, relativeURL) => (
    relativeURL ? `${baseURL.replace(/\/+$/, '')}/${relativeURL.replace(/^\/+/, '')}` : baseURL
);


/**
 * @returns {import('@microsoft/signalr').HubConnection}
 */
const createLiveUpdateConnection = (endpoint) => {  
    const hubUrl = combineURLs(process.env.REACT_APP_API_DOTNET || '', endpoint);
    console.debug(`/** ## SignalR ## Initializing connection to ${hubUrl}.`);

    const connection = new HubConnectionBuilder()
        .withUrl(hubUrl, {
            accessTokenFactory: () => sessionStorage.getItem('authToken').replace('Bearer ', ''),
        })
        .withAutomaticReconnect([0, 2000, 10000, 30000]) // Retry intervals
        .build();

    // Add connection state checking wrapper
    const originalInvoke = connection.invoke;
    connection.invoke = function(...args) {
        if (connection.state === 'Connected') {
            return originalInvoke.apply(this, args);
        } else {
            console.warn('/** ## SignalR ## Cannot invoke - connection not ready. State:', connection.state);
            return Promise.reject(new Error('Connection not ready'));
        }
    };

    connection.onreconnecting((error) => {
        console.debug('/** ## SignalR ## ON RECONNECTING, Error: ', error);
    });

    connection.onreconnected((connectionId) => {
        console.debug('/** ## SignalR ## ON RECONNECTED, ConnectionId: ', connectionId);
    });

    connection.onclose((error) => {
        console.debug('/** ## SignalR ## ON CLOSE, Error: ', error);
        // Attempt manual reconnection after a delay
        setTimeout(() => {
            if (connection.state === 'Disconnected') {
                console.debug('/** ## SignalR ## Attempting manual reconnection...');
                connection.start().catch(err => 
                    console.error('/** ## SignalR ## Manual reconnection failed:', err)
                );
            }
        }, 5000);
    });

    return connection;
};

export default createLiveUpdateConnection;
